import { Box, Stack } from '@mui/material';
import { AutoComplete, SelectBox, Switch } from '../../../../components/FormComponents';

function FeatureUsageAction(props) {
  const {
    toggleAll,
    setToggleAll,
    dropDown,
    selectedFilters,
    handleFilterChange,
  } = props;

  return (
    <Stack
      width="100%"
      justifyContent="space-between"
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'end', md: 'center' }}
      gap={2}
    >
      <Stack
        spacing={1}
        width={{ xs: '100%', md: '70%', lg: '50%' }}
        direction={{ xs: 'column', sm: 'row' }}
      >
        <Box flex={1} className="tg-sortby-filter">
          <SelectBox
            name="sortBy"
            title="Sort By"
            data={dropDown.sortBy}
            value={selectedFilters.sortBy}
            onChange={handleFilterChange}
          />
        </Box>

        <Box flex={1} className="tg-view-filter">
          <SelectBox
            name="featureUsageView"
            title="View"
            data={dropDown.featureUsageView}
            value={selectedFilters.featureUsageView}
            onChange={handleFilterChange}
          />
        </Box>

        <Box flex={1} minWidth="200px" className="tg-kpi-filter">
          <AutoComplete
            multiple
            label="Features"
            name="selectedFeatures"
            options={dropDown.selectedFeatures}
            value={selectedFilters.selectedFeatures}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(_, newValue) => handleFilterChange({
              target: {
                name: 'selectedFeatures',
                value: newValue,
              },
            })}
            highlighted={selectedFilters.selectedFeatures.length}
          />
        </Box>
      </Stack>

      <Stack width="auto" className="tg-expand-all">
        <Switch label="Expand All" value={toggleAll} onChange={setToggleAll} />
      </Stack>
    </Stack>
  );
}

export default FeatureUsageAction;
